<ispui-tooltip
  class="hint"
  [placement-order]="[
    'topLeft',
    'topRight',
    'right',
    'bottomLeft',
    'bottomRight'
  ]"
  [attach-selector]="hintAttachContainer | formIdPrefix"
  [scroll-selector]="hintAttachContainer | formIdPrefix"
  [tooltip-class]="'isp-field-base-hint'"
  [class.hint_invisible]="!visible"
  #tooltip
>
  <div slot="content" [innerHTML]="hintMsg"></div>
  <isp-svg-icon name="banner2-icon" size="14px"> </isp-svg-icon>
</ispui-tooltip>
